<template>
    <div class="rich-text-container">
        <div v-html="richText" class="rich-text-content"></div>
    </div>
</template>

<script>
import { getCmsByCodeApi } from "@/api/cms"
export default {
    name: 'BecomePartner',
    data() {
        return {
            richText: ''
        };
    },
    created() {
        this.fetchData()
    },
    methods: {
        async fetchData() {
            try {
                let tempParams = {
                    code: 'becomePartner'
                }
                let res = await getCmsByCodeApi(tempParams)
                const { code, content } = res || {}
                if (code === 200) {
                    this.richText = content.content
                }

            } catch (error) {

            }

        }
    }
};
</script>

<style scoped>
.rich-text-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2vw 2vh;
    height: 100vh;
    box-sizing: border-box;
}

.rich-text-content {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    font-size: 4vw;
    line-height: 1.4;
    word-wrap: break-word;
    word-break: break-all;

}

.rich-text-content>>>a {
    color: #007BFF;
    text-decoration: underline;
    font-weight: bold;
}

.rich-text-content>>>a:hover {
    color: #0056b3;
}

.rich-text-content>>>img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 2vw auto;
    object-fit: cover;
}

.rich-text-content>>>h1 {
    font-size: 6vw;
    margin-bottom: 3vw;
}

.rich-text-content>>>p {
    margin-bottom: 2vw;
}

a {
    color: #fe74ae;
    text-decoration: underline;
    font-weight: bold;
}

a:hover {
    color: #fe74ae;
}

/* 不同屏幕尺寸的适配 */
@media (min-width: 320px) and (max-width: 480px) {
    /* 小屏幕手机 */
    font-size: 5vw;
}

@media (min-width: 481px) and (max-width: 768px) {
    /* 大屏幕手机和平板 */
    font-size: 3vw;
}

@media (min-width: 769px) {
    /* 更大屏幕设备 */
    font-size: 1.5vw;
}
</style>